import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/installment';
import InstallmentModel from '../models/installment.m';
import {apiback} from '../../../config';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            selectedType: 'installment',
            model: {},
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };

        this.crefs = {};
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    componentWillMount() {
        fetch(apiback('INSTALLMENT'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new InstallmentModel(json.data.installment, this.state.selectedType)
                })
            );
        // .catch(x => console.log("error:", x)); todo добавить обработчик
    }
    componentWillReady() {
        this.widgetsHelper.getWidgets.call(this);
    }

    static displayName = 'Credit.Views.Installment';

    static contextTypes = {
        app: PropTypes.object
    };
}
